import styled from 'styled-components';

const FlexPadding = styled.div`
  flex: 1 1 auto;
  align-items: center;
`;

export default FlexPadding;
